// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/5e8828c0/" + chunkId + "." + __webpack_require__.h() + ".v5e8828c0.js";
};